export default __webpack_public_path__ + "static/media/ecom.783a82bd.png";